export default "__VITE_ASSET__CZ8TMip5__"